import React, { useState, useEffect } from "react";
import "./login.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import Swal from 'sweetalert2';
import { insertScore, updateReport, alreadyPlayed } from "../../scoreservice";


function Login({ updateHeader }) {
  const location = useLocation();

  // Use URLSearchParams to access the query parameters
  const queryParams = new URLSearchParams(location.search);
  const getOtp = queryParams.get('otp');
  const role = queryParams.get('role');
  const fromMobileApp =
    String(queryParams.get("fromMobileApp") || "").toLowerCase() === "true";
  const [otp, setOtp] = useState(getOtp);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // To control login state
  const [themeData, setThemeData] = useState(null);
  const [riddlerusLogo, setRiddlerusLogo] = useState("/img/logo.png");
  const navigate = useNavigate();
  const [isLogoSet, SetIsLogoSet] = useState(false);

  function handleError(msg) {
    Swal.fire({ icon: "error", title: "Oops...", text: msg });
  }

  const handleSuccess = (msg) => {
    return Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: msg,
      confirmButtonText: 'OK',
      customClass: { popup: 'custom-success-popup' }
    }).then(result => {
      return result; // Ensure we return the result
    });
  };

  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  function generateRandomUser() {
    const randomString = 'demo' + Math.floor(Math.random() * 10000);
    return {
      data: {
        data: {
          id: Math.floor(Math.random() * 100000),
          email: `${randomString}@gmail.com`,
          userId: randomString,
          firstName: randomString,
          lastName: randomString,
          employeeId: `EM${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
          sessionId: "demobypass",
          organizationId: "demobypass",
          roles: "demoRoles",
          reportId: `Report${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`
        }
      }
    };
  }
  const handleLogin = () => {
    if (queryParams.get('save')) {
      console.log("ignoring latest update...");
    } else {

      if (queryParams.get('demo') === 'true') {
        // const userId=;
        // const email=;
        // const firstName=;
        const response = generateRandomUser();

        loginCheck(response, "demo");
      } else {

        let apiUrl;
        const requestData = { otp: otp };
        let source = null;

        if (role === 'GUEST_USER') {
          apiUrl = process.env.REACT_APP_FIREBASE_GUEST_USER_API;
          requestData.role = 'GUEST_USER';
          source = 'GUEST_USER'
        } else {
          apiUrl = process.env.REACT_APP_FIREBASE_LOGIN_API;
          source = 'ORG_USER'
        }


        const headers = {
          'client-secret': process.env.REACT_APP_CLIENT_SECRET,
          'Content-Type': 'application/json'
        };

        const method = "POST";
        if (["POST", "PUT"].includes(method)) {
          headers["Idempotency-Key"] = uuidv4();
          console.log("Added Idempotency-Key:", headers["Idempotency-Key"]);
        }

        console.log(apiUrl);
        axios.post(apiUrl, requestData, { headers })
          .then(response => {
            console.log("API TRIGGER", response);
            if (response.data.message === 'LOGIN SUCCESS') {
              axios.get(
                process.env.REACT_APP_ORG_API + "/" + response.data.data.organizationId,
                { headers } // Ensure headers are included properly
              )
                .then(responseOrg => {
                  if (responseOrg.data.message === 'ORGANIZATIONS_FETCHED_SUCCESSFULLY') {
                    // Same lookup as the reference games: org logo on the S3 source bucket, else EM logo
                    const orgLogo = String(responseOrg.data?.organization?.companyLogo ?? "").trim();
                    const s3Base = process.env.REACT_APP_S3_SOURCE || "";
                    const hasLogo = orgLogo && !["null", "undefined"].includes(orgLogo.toLowerCase());
                    const companyLogo = hasLogo
                      ? /^https?:\/\//i.test(orgLogo)
                        ? orgLogo
                        : `${s3Base.endsWith("/") ? s3Base : `${s3Base}/`}${orgLogo}`
                      : process.env.REACT_APP_EM_LOGO;

                    updateHeader({
                      imageUrl: companyLogo,
                      backButtonRedirect: process.env.REACT_APP_BASE_URL + "/game-detail/" + response.data.data.gameId,
                    });
                  }
                  console.log("responseOrg", responseOrg);
                })
                .catch(error => {
                  console.error("Error fetching organization:", error);
                  updateHeader({ imageUrl: process.env.REACT_APP_EM_LOGO });
                });
              loginCheck(response, source);
            } else {
              handleError('Login failed! Please try again.');
            }

          })
          .catch(error => {
            console.error('Login Failed:', error.response?.data?.err?.message || 'An error occurred');
            handleError('Login failed! Please try again.');

          });
      }
    }
  };

  function loginCheck(response, source) {

    // Clear any existing game state when entering intro page
    try {
      sessionStorage.removeItem("gameState_v1");
    } catch (e) { /* ignore */ }
    console.log("loginCheck", response);

    const userId = role === 'GUEST_USER' ? response.data.data.id : response.data.data.userId;

    let name = `${response.data.data.firstName} ${response.data.data.lastName}`;
    let email;
    let token;

    if (role === 'GUEST_USER') {
      token = "";
      if (!response.data.data.firstName) {
        if (response.data.data.email) {
          name = response.data.data.email.split('@')[0];
          email = response.data.data.email;
        } else if (response.data.data.employeeId) {
          name = response.data.data.employeeId;
          email = response.data.data.employeeId;
        } else {
          name = 'Guest';
        }
      } else {
        name = response.data.data.firstName;
        email = response.data.data.email || response.data.data.employeeId;
      }
    } else {
      email = response.data.data.email;
      token = response.data.data.token;
    }

    const userData = {
      userId: userId,
      sessionId: response.data.data.sessionId,
      organizationId: response.data.data.organizationId,
      roles: role === 'GUEST_USER' ? 'GUEST_USER' : response.data.data.role,
      name: name,
      gameId: response.data.data.gameId,
      email: email,
      expiry: new Date().getTime() + 24 * 60 * 60 * 1000,
      source: source,
      token: token,
      fromMobileApp: fromMobileApp ? "true" : "false"
    };
    if (fromMobileApp) {
      sessionStorage.setItem("fromMobileApp", "true");
    } else {
      sessionStorage.removeItem("fromMobileApp");
    }
    console.log("userData", userData);

    // remembered so that opening /admin later (without the url parameters) uses this game session, as in savethem
    try {
      localStorage.setItem(
        "adminGameSession",
        JSON.stringify({ sessionId: userData.sessionId, organizationId: userData.organizationId, userId: userData.userId })
      );
    } catch {
      /* storage unavailable */
    }

    if (queryParams.get('admin')) {
      sessionStorage.setItem('userData', JSON.stringify(userData));

      navigate(
        `/admin?sessionId=${userData.sessionId}&userId=${userData.userId}&gameId=${userData.gameId}&organizationId=${userData.organizationId}`
      );
    } else {

      // Fetch theme data (same in both cases)
      const themeUrl = `${process.env.REACT_APP_BACKEND_URL}/fetchThemeData?sessionId=${userData.sessionId}&userId=${userData.userId}&organizationId=${userData.organizationId}`;
      console.log("themeUrl", themeUrl);
      fetch(themeUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((json) => {
          // setThemeData(json);
          sessionStorage.setItem('themeData', JSON.stringify(json));
          setThemeData(json);
          console.log(json);
          // callReportAPIAndContinue(userData);
          callPhpReportAPI(userData);

        })

    }

  }

  function callPhpReportAPI(userData) {


    let reportData = {
      userId: userData.userId,
      sessionId: userData.sessionId,
      organizationId: userData.organizationId,
      roles: userData.roles,
      name: userData.name,
      email: userData.email,
      gameId: userData.gameId,
      points: 0,
      time: "00:00"

    };

    const reportData1 = {
      userId: userData.userid || userData.userId,
      sessionId: userData.sessionId,
      organizationId: userData.organizationId
    };

    console.log("reportData1--------", reportData1);

    alreadyPlayed(reportData1)
      .then(res => {

        // if PHP returned false or empty
        if (!res) {
          return; // print nothing
        }
        const data = typeof res === "string" ? JSON.parse(res) : res;
        console.log("alreadyPlayed data", data);

        // Show popup ONLY if backend says gameover=true ("Already Played")
        if (data?.status === "success" && String(data?.message || "").toLowerCase() === "already played") {
          // handleSuccess("You have already played").then(result => {
          //   if (result.isConfirmed) {
          //     window.location.href = process.env.REACT_APP_BASE_URL;
          //   }
          // });
          Swal.fire({
            icon: "info",
            text: "You have already played",
            confirmButtonText: "OK"
          }).then(() => {
            // In mobile-app wrapper: let the native container handle navigation
            if (String(userData?.fromMobileApp || "").toLowerCase() === "true") {
              window.GameStatus?.postMessage?.("navigate_back");
              return;
            }
            window.location.href = process.env.REACT_APP_BASE_URL;
          });
        } else {
          insertScore(reportData).then((res) => {
            console.log("Insert response:", res);

            if (userData.source == "demo") {
              setIsLoggedIn(true);
              sessionStorage.setItem('userData', JSON.stringify(userData));

            } else {
              if (res.status === "exists") {
                console.log("Already inserted, record:", res.data);
                res.data.token = userData.token;
                callReportAPIAndContinue({ ...res.data, ...userData });
              } else if (res.status === "success") {
                console.log("New score inserted.");
                callReportAPIAndContinue(userData);
              }
            }
          })
        }
      })
      .catch(err => {
        console.error(err);
      });


  }

  function callReportAPIAndContinue(userData) {

    let updatedUserData = { ...userData };
    const isGuest = role === "GUEST_USER" || userData.roles === "GUEST_USER" || userData.source === "GUEST_USER";
    console.log("updatedUserData", updatedUserData);
    // If reportId already exists, skip API call but update sessionStorage
    if (updatedUserData.reportid || updatedUserData.reportId) {
      console.log("reportId already exists in userData, skipping report API call.");
      setIsLoggedIn(true);
      sessionStorage.setItem('userData', JSON.stringify(updatedUserData));

    } else {

      const reportUrl = isGuest
        ? `${process.env.REACT_APP_REPORTS_BASE_URL}/game/add/guest/score`
        : `${process.env.REACT_APP_REPORTS_BASE_URL}/game-server/report/add`;

      console.log("reportUrl", reportUrl);

      const reportRequestData = isGuest
        ? {
          gameId: userData.gameId,
          name: userData.name,
          sessionId: userData.sessionId,
          userId: userData.userId,
          organizationId: userData.organizationId,
          points: 0,
          time: "00:00:00",
          ans: ""
        }
        : {
          points: 0,
          time: "NA"
        };

      let headers = {
        "client-secret": process.env.REACT_APP_CLIENT_SECRET,
        "Content-Type": "application/json",
      };

      if (!isGuest) {
        headers["Authorization"] = `Bearer ${userData.token}`;
      }

      const method = "POST";
      if (["POST", "PUT"].includes(method)) {
        headers["Idempotency-Key"] = uuidv4();
        console.log("Added Idempotency-Key:", headers["Idempotency-Key"]);
      }

      axios.post(reportUrl, reportRequestData, { headers })
        .then(reportResponse => {
          console.log(reportResponse);

          // the id sits in a different place for guest / registered players (same lookup as savethem's extractReportIdFromResponse)
          const body = reportResponse.data || {};
          const reportId = [
            body.data?.reportId,
            body.data?.report_id,
            body.data?.id,
            body.reportId,
            body.report_id,
            body.id,
          ].find((v) => v != null && String(v).trim() !== "");
          console.log("Report add response:", body, "-> reportId:", reportId);

          if (reportId) {
            updatedUserData.reportId = String(reportId).trim();
            console.log("Report ID set:", updatedUserData.reportId);
            sessionStorage.setItem('userData', JSON.stringify(updatedUserData));

            updateReport(updatedUserData).then((updateRes) => {
              console.log("Report Id Update response:", updateRes);
            }).finally(() => setIsLoggedIn(true));
          } else {
            // the report server answered without an id: the player can still play, the update just has nothing to update
            console.warn("No reportId found in the report response");
            sessionStorage.setItem('userData', JSON.stringify(updatedUserData));
            setIsLoggedIn(true);
          }
        })
        .catch(error => {
          // reporting is non-fatal (as in savethem): let the player start, the failure is only logged
          console.error('Report add failed:', error.response?.data || error.message);
          sessionStorage.setItem('userData', JSON.stringify(updatedUserData));
          setIsLoggedIn(true);
        });
    }
  }


  useEffect(() => {
    // First-time login
    const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
    if (storedUserData) {
      sessionStorage.removeItem('userData');
    }
    const mobileLaunch =
      String(new URLSearchParams(window.location.search).get("fromMobileApp") || "").toLowerCase() ===
      "true";
    if (!mobileLaunch) {
      sessionStorage.removeItem("fromMobileApp");
    }
    handleLogin();
  }, []); // Runs once on component mount

  useEffect(() => {

  if (!themeData) return;

  const body = document.body;

  const updateBackground = () => {

    const isMobile = window.innerWidth <= 768;
    const isPortrait = window.matchMedia("(orientation: portrait)").matches;

    let backgroundImage;

    if (isMobile && isPortrait) {
      // ✅ Mobile Portrait
      backgroundImage = themeData.background_mob;
    } else {
      // ✅ Landscape Mobile + Desktop
      backgroundImage = themeData.background_desk;
    }

    if (body.classList.contains("common-bg")) {
      body.style.backgroundImage = `url(${backgroundImage})`;
    }
  };

  updateBackground(); // initial load
  window.addEventListener("resize", updateBackground);

  setRiddlerusLogo(themeData.logo);
  SetIsLogoSet(true);

  return () => {
    window.removeEventListener("resize", updateBackground);
  };

}, [themeData]);



  useEffect(() => {
    setTimeout(function () {
      if (queryParams.get('save')) {
        let getThemeData = sessionStorage.getItem('themeData');
        getThemeData = JSON.parse(getThemeData);
        console.log(getThemeData);
        let body = document.body;
        setIsLoggedIn(true);
        if (getThemeData) {
          if (body.classList.contains('common-bg')) {
            console.log(getThemeData.background_desk);
            console.log(getThemeData.logo);
            body.style.backgroundImage = `url(${getThemeData.background_desk})`;
            setRiddlerusLogo(getThemeData.logo);
            SetIsLogoSet(true);
          } else {
            console.log("not able to find common bg");
          }
          console.log("sessioin state updated!");
        }
      }
    }, 1000);
  }, []);

  return (
    <>
    {/* Mobile portrait overlay advising rotation */}
      <div className="rotate-overlay">
        <div className="rotate-message">
          Please rotate your device for best experience
        </div>
      </div>
      <div className="login-main-container" style={{ textAlign: "center" }}>

        {
          (isLogoSet) ?
            <div className="login-main-container1" style={{ textAlign: "center" }}>
              <img src={riddlerusLogo} className="login-logo" />
            </div>
            :
            <>
              <div className="loader">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
              </div>
            </>

        }
        {isLoggedIn ? (
          <div style={{ textAlign: "center" }}>
            <Link to="/game">
              <button
                type="button"
                className="begin-play-img1"
                style={{
                  backgroundColor: themeData?.button_color || "#000",
                  color: themeData?.landing_page_title_color || "#fff"
                }}
              >
            START
              </button>
            </Link>
          </div>
        ) : null}

      </div>
    </>
  );
}

export default Login;